import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Claim } from 'src/app/models/billing/claims-model';
import { AthenaDocument, AthenaVital } from 'src/app/models/emr/athena-data-models';
import { environment } from 'src/environments/environment';
import { SearchAthenaDepartmentRes, SearchAthenaProviderRes } from '../models/athena.model';
import { UtilsService } from '../utils.service';
import { CommonEmrService } from './common-emr.service';

@Injectable({
  providedIn: 'root',
})
export class AthenaService implements CommonEmrService {
  baseUrl = '/api/v1/integrations';
  patientSearch = '/athena/patients';
  claimsUrl = '/billing/claims';
  sectionnoteUrl = '/athena/sectionnote';
  documentCreateUrl = '/athena/document';
  vitalCreateUrl = '/athena/vital';
  providersUrl = '/athena/providers';
  clinicalproviderUrl = '/athena/clinicalproviders';
  departmentsUrl = '/athena/departments';

  constructor(private http: HttpClient, private utilservice: UtilsService) {}

  searchPatients(params): Observable<any[]> {
    const qParams = this.utilservice.getQueryStringFromParams(params);
    const url = `${environment.welbyEndpoint}${this.baseUrl}${this.patientSearch}`;
    return this.http.get<any[]>(`${url}${qParams}`);
  }

  createClaim(claim: Claim): Observable<any[]> {
    const url = `${environment.welbyEndpoint}${this.baseUrl}${this.claimsUrl}`;
    return this.http.post<any[]>(`${url}`, claim);
  }

  createDocument(doc: AthenaDocument): Observable<any[]> {
    const url = `${environment.welbyEndpoint}${this.baseUrl}${this.documentCreateUrl}`;
    return this.http.post<any[]>(`${url}`, doc);
  }

  createVital(vital: AthenaVital): Observable<any[]> {
    const url = `${environment.welbyEndpoint}${this.baseUrl}${this.vitalCreateUrl}`;
    return this.http.post<any[]>(`${url}`, vital);
  }

  createSectionNote(qparams, body): Observable<{ success: boolean; errorMessage?: string }> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });
    const qparamsString = this.utilservice.getQueryStringFromParams(qparams);
    const params = new HttpParams().set('sectionnote', body.sectionnote).set('departmentid', body.departmentId);
    const url = `${environment.welbyEndpoint}${this.baseUrl}${this.sectionnoteUrl}`;
    return this.http.post<{ success: boolean; errorMessage?: string }>(`${url}${qparamsString}`, params.toString(), {
      headers,
    });
  }
  searchProvidersByName(name: string, clientId: string): Observable<SearchAthenaProviderRes> {
    const url = `${environment.welbyEndpoint}${this.baseUrl}${this.providersUrl}`;
    const body = { name, client_id: clientId };
    return this.http.post<SearchAthenaProviderRes>(`${url}`, body);
  }

  searchDepartments(name: string, clientId: string): Observable<SearchAthenaDepartmentRes> {
    const url = `${environment.welbyEndpoint}${this.baseUrl}${this.departmentsUrl}`;
    const params = new HttpParams().set('name', name).set('client_id', clientId);
    return this.http.get<SearchAthenaDepartmentRes>(url, { params });
  }

  searchClinicalProvidersByName(
    firstName: string,
    lastName: string,
    clientId: string
  ): Observable<SearchAthenaProviderRes> {
    const url = `${environment.welbyEndpoint}${this.baseUrl}${this.clinicalproviderUrl}`;
    const body = { firstName, lastName, client_id: clientId };
    return this.http.post<SearchAthenaProviderRes>(`${url}`, body);
  }
}
